module.exports = __webpack_public_path__ + "static/media/org_code.7bfa1ba3.svg";